import React from "react";

const index = () => {
  return (
    <div>
      <footer className="main-footer">
        <div className="float-right d-none d-sm-inline-block">
          <b>Desarollo Web</b> corpodatos.com
        </div>
      </footer>
    </div>
  );
};

export default index;
